import { Heart, ShieldCheck, Sparkles, ArrowUpRight, QrCode } from "lucide-react";
import { useDonation } from "@/context/DonationContext";

const AMOUNTS = [
  { v: 30, label: "Um kit escolar" },
  { v: 80, label: "Uma cesta básica" },
  { v: 150, label: "Um mês de cuidado" },
  { v: 500, label: "Uma família inteira" },
];

export default function Doacao() {
  const { openModal } = useDonation();

  return (
    <section
      id="doar"
      data-testid="doacao-section"
      className="section-pad relative overflow-hidden bg-ga-emerald text-white"
    >
      <div
        className="absolute inset-0 opacity-20 pointer-events-none mix-blend-overlay"
        style={{
          backgroundImage:
            "radial-gradient(at 20% 20%, #F59E0B 0%, transparent 50%), radial-gradient(at 80% 80%, #0F172A 0%, transparent 50%)",
        }}
      />

      <div className="container-ga relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <div className="pill border-white/30 text-white bg-white/10 mb-6" data-testid="doacao-pill">
              <Heart className="w-3.5 h-3.5" />
              Doação
            </div>
            <h2 className="font-display font-black tracking-tighter text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">
              Faça parte dessa <br />
              <span className="underline decoration-ga-amber decoration-[8px] underline-offset-4">
                missão
              </span>
              .
            </h2>
            <p className="mt-8 text-white/90 text-lg sm:text-xl max-w-xl leading-relaxed">
              Sua contribuição ajuda a transformar vidas todos os dias. Escolha
              o caminho que faz sentido para você, seja uma doação pontual ou
              mensal.
            </p>

            <ul className="mt-8 space-y-2 text-white/90 text-base sm:text-lg">
              <li className="flex items-center gap-3">
                <ShieldCheck className="w-5 h-5 text-ga-amber shrink-0" />
                Pagamento direto via Pix, sem intermediários
              </li>
              <li className="flex items-center gap-3">
                <ShieldCheck className="w-5 h-5 text-ga-amber shrink-0" />
                Recibo disponível para declaração de Imposto de Renda
              </li>
              <li className="flex items-center gap-3">
                <ShieldCheck className="w-5 h-5 text-ga-amber shrink-0" />
                Prestação de contas trimestral pública
              </li>
            </ul>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl">
              <button
                type="button"
                onClick={() => openModal("doacao-pix")}
                data-testid="doacao-btn-pix"
                className="group inline-flex items-center justify-center gap-2 rounded-full bg-white text-ga-ink font-black py-4 px-8 text-base sm:text-lg shadow-xl hover:-translate-y-1 transition-transform"
              >
                <Heart className="w-5 h-5 fill-ga-emerald text-ga-emerald" />
                Doar com Pix
                <ArrowUpRight className="w-5 h-5 group-hover:translate-x-0.5 transition-transform" />
              </button>
              <button
                type="button"
                onClick={() => openModal("doacao-qrcode")}
                data-testid="doacao-btn-qrcode"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-ga-ink text-white font-bold py-4 px-8 text-base hover:bg-ga-ink/80 transition-colors"
              >
                <QrCode className="w-5 h-5" />
                Ver QR Code
              </button>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="glass rounded-[2rem] p-7 text-ga-ink shadow-2xl border border-white/40">
              <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-bold text-ga-emerald mb-4">
                <Sparkles className="w-3.5 h-3.5" /> Escolha um valor sugerido
              </div>
              <div className="grid grid-cols-2 gap-3">
                {AMOUNTS.map((a) => (
                  <button
                    type="button"
                    key={a.v}
                    onClick={() => openModal(`amount-${a.v}`)}
                    data-testid={`doacao-amount-${a.v}`}
                    className="group rounded-2xl border-2 border-ga-ink/10 hover:border-ga-emerald hover:bg-ga-emerald/5 transition-all p-4 text-left"
                  >
                    <div className="font-display font-black text-3xl text-ga-ink group-hover:text-ga-emerald transition-colors">
                      R${a.v}
                    </div>
                    <div className="text-xs text-ga-ink/60 mt-1">{a.label}</div>
                  </button>
                ))}
              </div>
              <button
                type="button"
                onClick={() => openModal("amount-custom")}
                data-testid="doacao-custom-btn"
                className="mt-4 w-full flex items-center justify-between rounded-2xl border-2 border-dashed border-ga-ink/20 p-4 hover:border-ga-emerald hover:bg-ga-emerald/5 transition-all"
              >
                <div className="text-left">
                  <div className="font-bold text-ga-ink">Outro valor</div>
                  <div className="text-xs text-ga-ink/60">Personalizar doação</div>
                </div>
                <ArrowUpRight className="w-5 h-5 text-ga-ink" />
              </button>
              <p className="mt-5 text-center text-xs text-ga-ink/50">
                Todas as doações são confirmadas diretamente no Pix, sem taxa e sem intermediário.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
